import { mergeStyles } from '@fluentui/react';

export const URLViewStyles = {
    linkCard: mergeStyles({
        padding: '12px',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        backgroundColor: '#fff',
        transition: 'all 0.2s ease',
        '&:hover': {
            borderColor: '#0078d4',
            boxShadow: '0 2px 8px rgba(0, 120, 212, 0.1)'
        }
    })
};
